import { useTranslation } from 'react-i18next';

import Chip from '@mui/material/Chip';

interface SkillTypeChipProps {
  isCatalog: boolean;
  size?: 'sm' | 'md';
  'data-testid'?: string;
}

const SIZES = {
  sm: { height: 16, fontSize: 9 },
  md: { height: 20, fontSize: 10 },
} as const;

export function SkillTypeChip({ isCatalog, size = 'md', 'data-testid': testId }: SkillTypeChipProps) {
  const { height, fontSize } = SIZES[size];
  const { t } = useTranslation();

  return (
    <Chip
      label={t(isCatalog ? 'skills.type.ari' : 'skills.type.custom')}
      size="small"
      data-testid={testId}
      sx={(theme) => ({
        height,
        fontSize,
        fontWeight: 600,
        ...(isCatalog
          ? {
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
            }
          : {
              bgcolor: theme.palette.grey[700],
              color: theme.palette.grey[300],
            }),
      })}
    />
  );
}
